module.exports = "<!-- routing -->\n\n<router-outlet></router-outlet>\n"